import React from 'react';
import config from '../config/environment';

const EnvironmentInfo = ({ show = false }) => {
  if (!show) return null;

  const envConfig = config.getConfig();

  const containerStyle = {
    position: 'fixed',
    top: '10px',
    right: '10px',
    background: 'rgba(0, 0, 0, 0.8)',
    color: 'white',
    padding: '10px',
    borderRadius: '5px',
    fontSize: '12px',
    zIndex: 9999,
    fontFamily: 'monospace',
    maxWidth: '300px'
  };

  const labelStyle = {
    fontWeight: 'bold',
    color: '#ffd700'
  };

  const valueStyle = {
    color: '#90EE90',
    wordBreak: 'break-all'
  };

  return (
    <div style={containerStyle}>
      <div><span style={labelStyle}>Environment:</span> <span style={valueStyle}>{envConfig.environment}</span></div>
      <div><span style={labelStyle}>API URL:</span> <span style={valueStyle}>{envConfig.apiUrl}</span></div>
      <div><span style={labelStyle}>WebSocket URL:</span> <span style={valueStyle}>{envConfig.webSocketUrl}</span></div>
    </div>
  );
};

export default EnvironmentInfo;
